import { Box, Flex, Text } from '@skin-seoul/design-system';
interface LoyaltyPointsBannerProps {
  points: number;
}
export const LoyaltyPointsBanner = ({
  points
}: LoyaltyPointsBannerProps) => {
  return <Box position="relative" width="100%" borderRadius="8px" gradientFrom="#311275" gradientTo="#754DCC" bgGradient="to-tl" overflow="hidden" px={4} py={{
    base: 6,
    tablet: 4
  }} data-sentry-element="Box" data-sentry-component="LoyaltyPointsBanner" data-sentry-source-file="LoyaltyPointsBanner.tsx">
      {/* Content */}
      <Flex position="relative" zIndex={1} alignItems="center" justifyContent="space-between" height="100%" data-sentry-element="Flex" data-sentry-source-file="LoyaltyPointsBanner.tsx">
        {/* Title */}
        <Flex direction="column" data-sentry-element="Flex" data-sentry-source-file="LoyaltyPointsBanner.tsx">
          <Text textStyle="heading.h6.mobile" fontWeight="bold" color="primary.100" data-sentry-element="Text" data-sentry-source-file="LoyaltyPointsBanner.tsx">
            Your
          </Text>
          <Text textStyle="heading.h6.mobile" fontWeight="bold" color="primary.100" data-sentry-element="Text" data-sentry-source-file="LoyaltyPointsBanner.tsx">
            SkinSociety
          </Text>
        </Flex>

        {/* Points */}
        <Flex direction="column" gap={1} alignItems="flex-end" data-sentry-element="Flex" data-sentry-source-file="LoyaltyPointsBanner.tsx">
          <Text textStyle="label.small" fontWeight="regular" color="primary.100" data-sentry-element="Text" data-sentry-source-file="LoyaltyPointsBanner.tsx">
            Your Points
          </Text>
          <Text textStyle="heading.h6" fontWeight="bold" color="white" letterSpacing="-0.4px" data-sentry-element="Text" data-sentry-source-file="LoyaltyPointsBanner.tsx">
            {points} Pts
          </Text>
        </Flex>
      </Flex>
    </Box>;
};